import { createRouter, createWebHistory, RouteRecordRaw, RouteRecordSingleView } from "vue-router"
import { useCookies } from "vue3-cookies"
import { V1_ROUTER_LIST_ALL } from "@/api/const/router"
import { apiPost, apiGetNoParam, apiGet } from "@/api/index"
import commons from "@/utils/Common";

const _ = require('lodash');

interface AppRouteMeta extends Record<string | number | symbol, unknown> {
	title: string,
	description: string,
	layout: string,
	requiresAuth: boolean,
	breadcrumb: any[],
	imgBanner: string,
	id: string,
}

interface BackendRoute {
	path: string,
	name: string,
	component: string,
	redirect: string,
	meta: AppRouteMeta,
}

const { cookies } = useCookies()
let routes: RouteRecordRaw[] = []
await apiGetNoParam(V1_ROUTER_LIST_ALL).then((res) => {
	let response: any = res;
	let rawRoutes = response.data.data;
	for (const item of rawRoutes) {
		// Skip nếu thiếu path hoặc component
		if (!item.path || !item.component) continue;
		const route: RouteRecordRaw = {
			path: item.path.toLowerCase(),
			name: item.name,
			component: () => import(`../views${item.component}`),
			meta: {
				title: item.meta?.title ?? '',
				description: item.meta?.description ?? '',
				layout: item.meta?.layout ?? 'default',
				requiresAuth: item.meta?.requiresAuth ?? false,
				breadcrumb: item.meta?.breadcrumb ?? [],
				imgBanner: item.meta?.imgBanner,
				id: item.meta?.id
			}
		}

		if (item.redirect) {
			route.redirect = item.redirect
		}

		routes.push(route)
	}
});

function addLayoutToRoute(
	route: RouteRecordRaw,
	parentLayout?: string
): RouteRecordRaw {

	route.meta = route.meta || {}

	const layout =
		typeof route.meta.layout === 'string'
			? route.meta.layout
			: parentLayout ?? 'default'

	route.meta.layout = layout

	if (route.children?.length) {
		route.children = route.children.map(child =>
			addLayoutToRoute(child, layout)
		)
	}

	return route
}

routes = routes.map((route: any) => addLayoutToRoute(route));

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		// Vue Router 4: dùng `el` + `left`/`top`, không dùng `selector` hay `x`/`y` (tránh scrollTo sai + lỗi DOM khi điều hướng).
		if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth',
			}
		}
		if (savedPosition) {
			return savedPosition
		}
		return { left: 0, top: 0 }
	}
})
router.afterEach((to) => {
	const meta = to.matched.reduce<AppRouteMeta>((acc, record) => {
		Object.assign(acc, record.meta)
		return acc
	}, {
		title: '',
		description: '',
		layout: 'default',
		requiresAuth: false,
		breadcrumb: [],
		imgBanner: '',
		id: '',
	})

	const defaultTitle = 'Công ty cổ phần Kima Home'

	document.title = meta.title || defaultTitle

	const description = meta.description || defaultTitle

	let descriptionTag = document.querySelector('meta[name="description"]')
	if (!descriptionTag) {
		descriptionTag = document.createElement('meta')
		descriptionTag.setAttribute('name', 'description')
		document.head.appendChild(descriptionTag)
	}
	descriptionTag.setAttribute('content', description)

	// ✅ GIỜ ĐÂY SẼ CÓ
	console.log('11111111111', meta.id)
	console.log('id:', meta.id)
	console.log('imgBanner:', meta.imgBanner)
})


router.beforeEach((to, from, next) => {

    const isLoginer = true

    // ❗ Route không tồn tại (thực tế không cần vì đã có NotFound)
    if (to.matched.length === 0) {
        return next('/404')
    }

    // Auth
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isLoginer && to.path !== '/login') {
            return next('/login')
        }
    }

    next()
})

export default router
